import styled from "styled-components";

const Container = styled.div`
  margin: auto;
  width: 90%;
  max-width: 1100px;
  height: 100%;
`;

export default Container;
